import { render, staticRenderFns } from "./crm-settings-list.vue?vue&type=template&id=63c09d48&scoped=true&"
import script from "./crm-settings-list.vue?vue&type=script&lang=js&"
export * from "./crm-settings-list.vue?vue&type=script&lang=js&"
import style0 from "./crm-settings-list.vue?vue&type=style&index=0&id=63c09d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c09d48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VIcon,VSpacer,VTextField,VTooltip})
